import { HeadLine } from '../../../layouts/headers/HeadLine'

export const CrystalStd = () => {
    return (
        <>
            <div className='w-full absolute z-1 head-hi-sm flex flex-col justify-center'>
                <HeadLine title='Cristal International Std.' backurl='/hotel-info' />
            </div>
            <div className='w-full relative content-hi-sm'>
                <div className='p-2'>
                    <img className='m-auto' src="/assets/img/icons/group-icon.svg" alt="icono codigo de conducta" />
                </div>

                <div className='mt-4'>
                    <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ornare, dui facilisis imperdiet mattis, turpis velit porttitor turpis, sit amet blandit lorem risus eu urna. Integer elit massa, tristique at eros nec, viverra mattis orci. Aliquam sit amet facilisis nibh, id fermentum lacus. Integer ac velit faucibus, interdum tortor a, aliquam nibh. Praesent consectetur eros vel augue tempus, sit amet porttitor ex faucibus. Pellentesque condimentum nunc tortor. Quisque quam leo, imperdiet a turpis ac, interdum gravida elit. Suspendisse aliquam nulla sit amet ante pellentesque, et ullamcorper nunc accumsan. Vivamus urna libero, porta at mi ut, malesuada pharetra magna. Sed at accumsan massa. Pellentesque posuere tincidunt sollicitudin. Interdum et malesuada fames ac ante ipsum primis in faucibus. Nunc sed cursus arcu. Quisque tincidunt condimentum metus, in laoreet erat posuere sed. Suspendisse suscipit tristique odio.
                    </p>
                </div>
            </div>
        </>
    )
}
